<template>
  <div>
    <BaseLoadingBar v-if="pending" isSmall />

    <div v-if="!pending && events.length === 0" class="notification-event-list__empty">
      <BaseIcon name="check" />
      <span>{{ $t('notifications-center.empty') }}</span>
    </div>

    <div v-else class="notification-event-list">
      <NotificationEventGroup
        v-for="group in groupedEvents"
        :key="group.key"
        :group="group"
        @open="$emit('open', $event)"
        @mark-read="$emit('mark-read', $event)"
      />
    </div>
  </div>
</template>

<script>
import BaseIcon from '@/components/base/BaseIcon';
import BaseLoadingBar from '@/components/base/BaseLoadingBar.vue';
import NotificationEventGroup from '@/components/notifications-center/NotificationEventGroup.vue';
import { groupNotificationEvents } from '@/util/notification-changes-util';

export default {
  name: 'NotificationEventList',
  components: {
    BaseIcon,
    BaseLoadingBar,
    NotificationEventGroup,
  },
  props: {
    events: {
      type: Array,
      required: true,
    },
    pending: {
      type: Boolean,
      default: false,
    },
    competitors: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    groupedEvents() {
      return groupNotificationEvents(this.events, this.competitors);
    },
  },
};
</script>

<style lang="scss" scoped>
.notification-event-list {
  &__empty {
    display: flex;
    align-items: center;
    gap: $space-1;
    width: 100%;
    color: $color-text-muted;
    font-size: $font-size-small;

    .base-icon {
      flex-shrink: 0;
      width: 20px;
      height: 20px;
    }
  }
}
</style>
